import { useUISize } from 'app/utils/web-helpers';

interface ResponsiveProps {
  desktop?: React.ReactNode;
  mobile?: React.ReactNode;
}

function Responsive({ desktop, mobile }: ResponsiveProps) {
  const { isLargeUI } = useUISize();
  return isLargeUI ? desktop : mobile;
}

export default Responsive;
